<template>
  <div class="x-show-modal">
    <transition
      enter-class="modal-bg-hide"
      enter-active-class="modal-bg-show"
      leave-active-class="modal-bg-hide"
    >
      <div class="x-modal-bg" v-if="showModal"></div>
    </transition>
    <transition enter-active-class="modal-top-show" leave-active-class="modal-top-hide">
      <div class="x-modal" v-if="showModal">
        <div class="x-modal-box">
          <div class="x-header" v-if="header">
            <div class="left-title">{{ title }}</div>
            <div class="right-close" @click="close">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="x-content">
            <div v-if="content" class="x-tip-modal-title">{{ content }}</div>
            <rendering v-if="message" :render="message"></rendering>
          </div>
          <slot name="footer">
            <my-footer-btn
              v-if="!hideFooter && typeof message === 'string'"
              spacing="80px"
              padding="30px"
              :hideClose="hideClose"
              :hideConfirm="hideConfirm"
              :confirmText="confirmText"
              :closeText="closeText"
              @close="closeModal"
              @confirm="confirm"
            ></my-footer-btn>
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import rendering from '../render.js';
import i18n from '@/i18n/index.js';
export default {
  components: {
    rendering
  },
  model: {
    prop: 'show', // 要存在于proops
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    show: {
      // 是否显示
      type: Boolean,
      default: false
    },
    header: {
      // 是否隐藏标题
      type: Boolean,
      default: false
    },
    title: {
      // 标题
      type: String,
      default: () => i18n.t('HT.modal.title')
    },
    content: {
      // 内容
      type: String,
      default: ''
    },
    message: {
      // 自定义组件
      type: [String, Function],
      default: ''
    },
    hideFooter: {
      // 是否隐藏底部按钮
      type: Boolean,
      default: false
    },
    hideClose: {
      // 是否隐藏关闭按钮
      type: Boolean,
      default: false
    },
    hideConfirm: {
      // 是否隐藏确认按钮
      type: Boolean,
      default: false
    },
    closeText: {
      // 取消按钮文字
      type: String,
      default: () => i18n.t('HT.cancel2')
    },
    confirmText: {
      // 确认按钮文字
      type: String,
      default: () => i18n.t('HT.confirm2')
    },
    confirm: {
      type: Function,
      default: () => {
        return Function;
      }
    },
    close: {
      type: Function
    }
  },

  data() {
    return {
      showModal: this.show
    };
  },

  methods: {
    /**
     * 关闭
     */
    closeModal: function () {
      if (typeof this.close === 'function') {
        this.close();
      } else {
        this.showModal = false;
        this.$uxModal.hide();
      }
    }
  },

  watch: {
    showModal(val) {
      this.$emit('change', val);
    },
    show(val) {
      this.showModal = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.x-show-modal {
  position: relative;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  // 弹窗背景
  .x-modal-bg {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }

  // 弹窗布局盒子
  .x-modal {
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  // 弹窗框
  .x-modal-box {
    min-width: 400px;
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;

    // 弹窗标题
    .x-header {
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      height: 52px;
      border-bottom: 1px solid #f1f1f1;
      color: rgba(0, 0, 0, 0.7);

      .left-title {
        font-size: 16px;
      }

      .right-close {
        position: absolute;
        right: 0;
        top: 0;
        width: 52px;
        height: 52px;
        line-height: 52px;
        font-size: 20px;
        text-align: center;
        cursor: pointer;
      }

      .right-close:hover {
        color: #f14848;
      }
    }

    // 弹窗主题内容
    .x-content {
      padding: 30px 30px 20px 30px;
    }

    // 弹窗标题
    .x-tip-modal-title {
      max-width: 400px;
      margin-bottom: 15px;
      font-size: 16px;
      color: #1d2944;
      font-weight: 600;
      word-break: break-all;
    }
  }
}

.modal-top-show {
  animation: showAnimate 0.4s forwards;
}

.modal-top-hide {
  animation: hideAnimate 0.4s forwards;
}

.modal-bg-show {
  opacity: 1;
  transition: all 0.3s;
}

.modal-bg-hide {
  opacity: 0;
  transition: all 0.3s;
}

// 提示信息出现动画
@keyframes showAnimate {
  0% {
    opacity: 0;
    transform: translateY(-100px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

// 提示信息消失动画
@keyframes hideAnimate {
  0% {
    opacity: 1;
    transform: translateY(0px);
  }

  100% {
    opacity: 0;
    transform: translateY(-100px);
  }
}
</style>
